import { onPageLoad } from 'modules/page_lifecycle';

function bootstrapApi() {
  return globalThis.bootstrap;
}

export function bootstrapModal(id) {
  const bootstrap = bootstrapApi();
  if (!bootstrap?.Modal) return null;
  const element = document.getElementById(id);
  if (!element) return null;
  return bootstrap.Modal.getOrCreateInstance(element);
}

export function showModal(id) {
  bootstrapModal(id)?.show();
}

export function hideModal(id) {
  const element = document.getElementById(id);
  if (!element) return;

  const bootstrap = globalThis.bootstrap;
  if (bootstrap?.Modal) {
    bootstrap.Modal.getOrCreateInstance(element).hide();
    return;
  }

  element.classList.remove('show');
  element.style.display = 'none';
  element.setAttribute('aria-hidden', 'true');
  document.body.classList.remove('modal-open');
  document.querySelectorAll('.modal-backdrop').forEach((backdrop) => backdrop.remove());
}

export function onModalEvent(id, eventName, handler) {
  const element = document.getElementById(id);
  if (!element) return;
  element.addEventListener(eventName, handler);
}

export function bindTemplatePopovers(selectors, { title, templateId }) {
  onPageLoad(() => {
    const bootstrap = bootstrapApi();
    if (!bootstrap?.Popover) return;

    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((element) => {
        bootstrap.Popover.getOrCreateInstance(element, {
          trigger: 'hover focus',
          title,
          html: true,
          container: 'body',
          sanitize: false,
          content: () => document.getElementById(templateId)?.innerHTML || ''
        });
      });
    });
  });
}

export function initBootstrapTooltipsAndPopovers(root = document) {
  const bootstrap = bootstrapApi();
  if (!bootstrap) return;

  root.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((element) => {
    bootstrap.Tooltip.getOrCreateInstance(element);
  });

  root.querySelectorAll('.our-popover, [data-bs-toggle="popover"]').forEach((element) => {
    bootstrap.Popover.getOrCreateInstance(element);
  });
}
